import { Action } from "@reduxjs/toolkit";
import { BlogState } from "./types";
import { isType } from "typescript-fsa";
import { blogActions } from "./actions";

const initialState: BlogState = {
  total_items: 0,
  total_pages: 0,
  current_page: 1,
  page_size: 10,
  next_page: null,
  previous_page: null,
  data: [],
  detail: null, // Add detail field for individual blog
};

export function BlogReducer(state = initialState, action: Action): BlogState {
  if (isType(action, blogActions.getBlogs.done)) {
    return {
      ...state,
      total_items: action.payload.result.total_items,
      total_pages: action.payload.result.total_pages,
      current_page: action.payload.result.current_page,
      page_size: action.payload.result.page_size,
      next_page: action.payload.result.next_page,
      previous_page: action.payload.result.previous_page,
      data: action.payload.result.data.map((data) => ({
        id: Number(data.id),
        title: data.title,
        author_name: data.author_name,
        publish: data.publish,
        image: data.image,
        content: data.content,
        created_at: data.created_at,
      })),
    };
  }

  if (isType(action, blogActions.getBlogDetail.done)) {
    return {
      ...state,
      detail: {
        id: Number(action.payload.result.id),
        title: action.payload.result.title,
        author_name: action.payload.result.author_name,
        publish: action.payload.result.publish,
        image: action.payload.result.image,
        content: action.payload.result.content,
        created_at: action.payload.result.created_at,
      },
    };
  }

  if (isType(action, blogActions.resetToIntialState)) {
    return initialState;
  }

  return state;
}
